/* Transient UI overlays: the person quick-actions popover and the knock modal. */
import { defineStore } from 'pinia'
import type { Person } from '@/types/atrium'

interface Anchor { left: number; top: number; width: number; height: number; bottom: number }

interface UiState {
  personPopover: { person: Person; anchor: Anchor } | null
  knockFor: Person | null
  devPanel: boolean
  /** The knowledge node the quick-reader modal is showing (null = closed).
   *  Bumped on every open so re-opening the same node still triggers a load. */
  knowledgeNode: { id: string; nonce: number } | null
}

export const useUi = defineStore('ui', {
  state: (): UiState => ({ personPopover: null, knockFor: null, devPanel: false, knowledgeNode: null }),
  actions: {
    openDev() { this.devPanel = true },
    closeDev() { this.devPanel = false },
    toggleDev() { this.devPanel = !this.devPanel },
    /** Open the knowledge quick-reader on a graph node — from a link in chat,
     *  a ticket, anywhere. The reader fetches its own detail, so this never
     *  disturbs the full memory page's selection. */
    openKnowledge(id: string) {
      this.knowledgeNode = { id, nonce: (this.knowledgeNode?.nonce ?? 0) + 1 }
    },
    closeKnowledge() { this.knowledgeNode = null },
    openPerson(person: Person, rect: DOMRect) {
      this.personPopover = {
        person,
        anchor: { left: rect.left, top: rect.top, width: rect.width, height: rect.height, bottom: rect.bottom },
      }
    },
    closePerson() { this.personPopover = null },
    openKnock(person: Person) {
      this.personPopover = null
      this.knockFor = person
    },
    closeKnock() { this.knockFor = null },
  },
})
